Vendd.Scripts.load(function () {

    var $form = $('.x-registration-form-sso'), $submitButton, form, formData, $loyaltyErrorWrapper = $('.loyalty-error-container'),
        loyaltyRegistrationUrl;

    if ($form.length < 1)
        return;

    var loyaltyMemberCardNumberIsValid = true, loyaltyMemberCardNumberIsEnabled = $form.data('loyaltymembercardnumberisenabled');

    $submitButton = $('.js-submit-button', $form);

    form = $form.get(0);

    importEmailForRegistration();

    formData = {
        "title": $("option:selected", 'select[name=title]').text(),
        "newsletter": false,
        "redirectUrl": $form.data('redirect') || "",
        "phone": $('input[name="phone"]').val(),
        "mobilePhone": "", //$('input[name="mobilePhone"]').val()
        "socialSecurityNumber": $('input[name="socialSecurityNumber"]').val(),
        "registerToLoyalty": false,
        "isLoyaltyMember": false,
        "loyaltyRequest": false,
        "loyaltyMemberId": "",
        "alreadyRegisteredToLoyalty": false,
        "loyaltyMemberCardNumber": "",
        "postalCode": ""
    };

    var areas = [];

    form.getAreasForPostCode = function (envelope) {

        areas = envelope.message.data;

        //validate postal code.
        if (valOpts.postalCode && valOpts.postalCode.isValidPostalCode) {
            valOpts.postalCode.isValidPostalCode.config.areas = areas;
        }
        rf.validateField("postalCode");
    };

    form.loading = function (loading) {
        if (loading) {
            $form.addClass('x-loading');
        } else {
            $form.removeClass('x-loading');
        }
    };

    form.onSuccess = function (envelope) {
        form.loading(false);

        var response = envelope.message.data;
        if (response.success && response.code === "Registration_OperationSuccesful") {
            $('.js-error', $form).hide();
            $('.js-content', $form).hide();

            var isLoyaltyActivated = (formData.alreadyRegisteredToLoyalty || formData.registerToLoyalty);
            if (isLoyaltyActivated && formData.mobilePhone) {
                loyaltyRegistrationUrl = response.data.LoyaltyRegistrationUrl;
                Vendd.MessageBus.publishAsync(Vendd.Loyalty, new Vendd.Loyalty.Messages.CheckByMobile(formData.mobilePhone));
            } else {
                $('.js-success', $form).show();
            }

            $('.js-success', $form).show();

            $('html,body').animate({scrollTop: 0}, 300);

            /* Track User Registration */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'CompleteRegistration');
                }
            }
            /* END Track User Registration */

        } else {

            $('.js-error', $form).show();
            $('html,body').animate({scrollTop: $('.js-error', $form).offset().top - 100}, 300);

        }
    };

    form.onFailure = function (envelope) {
        form.loading(false);

        $('.js-error', $form).show();
        $('html,body').animate({scrollTop: $('.js-error', $form).offset().top - 100}, 300);
    };

    form.submit = function () {
        form.loading(true);

        formData.newsletter = $('#chkNewsletter').prop("checked");
        formData.registerToLoyalty = $('#chkRegisterToLoyaltyPoints').prop("checked");
        formData.alreadyRegisteredToLoyalty = $('#chkAlreadyRegisteredToLoyaltyPoints').prop("checked");

        formData.isLoyaltyMember = $('#isLoyaltyMember').prop("checked");
        formData.loyaltyRequest = $('#loyaltyRequest').prop("checked");

        $('input:not([type="checkbox"]), textarea:not([name="g-recaptcha-response"])', $form).each(function () {
            formData[$(this).attr('name')] = omitScriptTag($(this).val());
        });

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.CompleteSsoRegistration(
            formData.newsletter,
            formData.redirectUrl,
            formData.phone,
            formData.mobilePhone,
            formData.socialSecurityNumber,
            formData.isLoyaltyMember,
            formData.loyaltyRequest,
            formData.loyaltyMemberId,
            formData.loyaltyMemberCardNumber,
            formData.postalCode
        ));
    };

    form.reset = function () {
        $('.js-error', $form).hide();
        $('.js-success', $form).hide();
        $('.js-content', $form).show();

        $('input[name="phone"]', $form).val("");
        $('input[name="mobilePhone"]', $form).val("");
        $('input[name="socialSecurityNumber"]', $form).val("");
        $('input[name="loyaltyMemberCardNumber"]', $form).val("");
        $('input[name="postalCode"]', $form).val("");
        rf.reset();
    };

    $(".js-datepicker", $form).datepicker({
        changeMonth: true,
        changeYear: true,
        yearRange: "-100:+0",
        maxDate: "0"
    });

    form.setIsRegistered = function (isRegistered) {
        sessionStorage.setItem('LoyaltyIsRegistered', isRegistered);
    };

    var valOpts = {
        phone: {
            required: 'phone-required'
        },
        mobilePhone: {
            required: 'mobilePhone-required'
        },
        /*postalCode: {
             isValidPostalCode: { validator: 'postalCode-invalid', config: {country: 'GR', areas: areas } }
         }*/
    };

    if ($('input[name="postalCode"]', $form).length > 0 && $('.postalCode-required', $form).length > 0) {
        valOpts.postalCode = { ...valOpts.postalCode, ...{ required: 'postalCode-required' } };
    }

    if ($('input[name="socialSecurityNumber"]', $form).length > 0) {
        valOpts.socialSecurityNumber = {
            isSocialSecurityNumber: 'social-security-number'
        };
    }

    var prevLoyaltyMemberCardNumber = '';

    if (loyaltyMemberCardNumberIsEnabled) {
        $('input[name="loyaltyMemberCardNumber"]', $form).on('blur', function () {
            var loyaltyMemberCardNumber = $(this).val();
            var $formRow = $(this).closest('.form-row');
            loyaltyMemberCardNumber = loyaltyMemberCardNumber.replace(/\s/g, '');
            $(this).val(loyaltyMemberCardNumber);
            if (loyaltyMemberCardNumber == '') {
                $('.loyaltyMemberCardNumber-invalid', $formRow).hide();
                $formRow.removeClass('with-error');
                loyaltyMemberCardNumberIsValid = true;
            } else {
                if (loyaltyMemberCardNumber != prevLoyaltyMemberCardNumber) {
                    //omit script tag before ajax call
                    loyaltyMemberCardNumber = omitScriptTag(loyaltyMemberCardNumber);

                    $('.js-submit-button', $form).attr('disabled', 'disabled');
                    Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetMemberByLoyaltyNumber(loyaltyMemberCardNumber));
                    prevLoyaltyMemberCardNumber = loyaltyMemberCardNumber;
                }
            }
        });
    }

    //Validate Phone only if config parameter is true
    if (venddProjectConfigs.Account.RegexPhoneValidation) {
        valOpts.phone = { ...valOpts.phone, ...{ isRegexPhone: { validator: 'phone-invalid', config: { regex: venddProjectConfigs.Account.RegexPhoneValue } } } };
    } else {
        valOpts.phone = { ...valOpts.phone, ...{ isPhoneNumber: 'phone-invalid' } };
    }

    //Validate Mobile only if config parameter is true
    if (venddProjectConfigs.Account.RegexMobileValidation) {
        valOpts.mobilePhone = { ...valOpts.mobilePhone, ...{ isRegexMobile: { validator: 'mobilePhone-invalid', config: { regex: venddProjectConfigs.Account.RegexMobileValue } } } };
    } else {
        valOpts.mobilePhone = { ...valOpts.mobilePhone, ...{ isPhoneNumber: 'mobilePhone-invalid' } };
    }

    //add consent validations
    $.each($('div.consent.checkbox[data-required]', $form), function (e, el) {
        var consentType = $('input', el).attr('name');
        valOpts[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });

    var clickedCheckbox;
    var loyaltyCheckboxes = $('.js-loyalty-checkbox .checkbox-wrapper input', $form);
    loyaltyCheckboxes.removeAttr('disabled');

    $('.consent-wrapper', $form).each(function (e, el) {
        var $chkbx = $('.checkbox-wrapper > input', el);

        $chkbx.off('click').on('click', function () {
            var $this = $(this);

            if (!$this.is(':checked')) {
                var fieldName = $this.attr('name');

                formData[fieldName] = $this.is(':checked');
                rf = $form.data('validationEngine');
                rf.validate(fieldName);
                return;
            }

            var $text = $('.consent-text-wrapper', el);
            $.fancybox.open($text, {
                maxWidth: 900,
                padding: 0,
                modal: true,
                afterShow: function () {
                    var consentForm = $('.js-consent-form');
                    //var scrollContForm = $('.js-scrollbar', consentForm);
                    var closeButton = $('.js-consent-decline-button', consentForm);
                    var acceptButton = $('.js-consent-accept-button', consentForm);

                    //scrollContForm.mCustomScrollbar({
                    //    scrollbarPosition: "outside",
                    //    scrollInertia: 400,
                    //    timeout: 1000,
                    //    theme: "dark-2",
                    //    mouseWheel: {preventDefault: true},
                    //    callbacks: {
                    //        onTotalScrollOffset: 25,
                    //        onTotalScroll: function () {
                    //            consentForm.addClass('has-scrolled');
                    //            $('.js-consent-accept-button', consentForm).prop('disabled', false);
                    //            $('.js-tooltip', consentForm).addClass('hidden');
                    //        },
                    //        onInit: function () {
                    //            $('.js-scroll-btn', consentForm).addClass('show');
                    //        },
                    //        onCreate: function () {
                    //            setTimeout(function () {
                    //                if (scrollContForm.hasClass('mCS_no_scrollbar')) {
                    //                    consentForm.addClass('has-scrolled');
                    //                    $('.js-consent-accept-button', consentForm).prop('disabled', false);
                    //                    $('.js-tooltip', consentForm).addClass('hidden');
                    //                }
                    //            }, 100);
                    //        }
                    //    }
                    //});

                    //$('.js-scroll-btn', consentForm).click(function () {
                    //    scrollContForm.mCustomScrollbar('scrollTo', '-=' + (scrollContForm.height()));
                    //});

                    closeButton.off('click').on('click', function () {
                        //clickedCheckbox.prop("checked", false);
                        //$this.prop("checked", false);
                        $.fancybox.close(true);
                    });
                    acceptButton.off('click').on('click', function () {
                        //clickedCheckbox.prop("checked", true);
                        //$this.prop("checked", true);
                        $.fancybox.close(true);
                    });
                },
                afterClose: function () {

                    var fieldName = $this.attr('name');

                    formData[fieldName] = $this.is(':checked');
                    rf = $form.data('validationEngine');
                    rf.validate(fieldName);
                },
            });
        });
    });

    loyaltyCheckboxes.click(function (e) {
        clickedCheckbox = $(this);
        $('.consent-wrapper.loyalty .checkbox-wrapper > input', $form).trigger('click');
    });

    $form.validationEngine(valOpts);
    var rf = $form.data('validationEngine');

    var val3 = true;
    $form.on('click', '.js-submit-button', function (e) {
        valOpts = $form.validationEngine();

        $form.validationEngine(valOpts);
        rf = $form.data('validationEngine');

        e.preventDefault();
        e.stopPropagation();

        var val1 = true;//form.validateRecaptcha();
        var val2 = rf.validate();

        if (val1 && val2 && val3 && loyaltyMemberCardNumberIsValid) {
            if (LhApp.Context.IsConsentsEnabled) {
                form.checkConsents();
            } else {
                form.submit();
            }
        } else {
            if ($('.form-row.with-error', $form).length > 0) {
                $('html,body').animate({scrollTop: $('.form-row.with-error', $form).first().offset().top - 100}, 600);
            }
        }
    });

    form.checkConsents = function () {
        var data = [];
        var checkboxes = $('.form-row.consent.checkbox');
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({type: chkbx.attr('id'), source: 'Registration Form', approved: chkbx.prop("checked")});
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            form.submit();
        }
    };

    $form.on('change', 'select[name]', function (e) {
        form.setField($(this));
    });

    $form.on('change', '.js-datepicker', function (e) {
        $(this).trigger('keyup');
    });

    $form.on('keyup', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        }

        if ($(this).attr('name') === "postalCode") {
            removeWhiteSpaces($(this));
        }

        form.setField($(this));
    });

    $form.on('keyup', 'input[name = "postalCode"]', $.debounce(400, function () {
        var $this = $(this);
        var postalCode = $this.val();

        if (postalCode === null) return;

        Vendd.MessageBus.publishAsync(form, new Vendd.User.Messages.GetAreasForPostCode("GR", postalCode, ""));
    }));

    $form.on('blur', 'input[name]:not([type="checkbox"]), textarea[name]', function (e) {
        form.setField($(this));
    });

    form.setField = function (field) {
        var fieldName = field.attr('name');
        rf.validate(fieldName);
    };

    $form.on('click', 'input.single-check', function () {
        $('input.single-check').not(this).prop('checked', false);
        formData.registerToLoyalty = $('#chkRegisterToLoyaltyPoints').prop("checked");
        formData.alreadyRegisteredToLoyalty = $('#chkAlreadyRegisteredToLoyaltyPoints').prop("checked");
        var isLoyaltyRegistered = formData.registerToLoyalty || formData.alreadyRegisteredToLoyalty;
        $('.consent-wrapper', $form).each(function (e, el) {
            var $chkbx = $('.checkbox-wrapper input', el);
            var chkbxId = $chkbx.attr('id');
            if (chkbxId != undefined && chkbxId != "") {
                valOpts = $form.validationEngine();
                formData[chkbxId] = $chkbx.prop("checked");
                valOpts[chkbxId] = isLoyaltyRegistered ? {checkboxRequired: (chkbxId + '-required')} : {};
                $form.validationEngine(valOpts);
            }
            if (isLoyaltyRegistered) {
                $form.data('validationEngine').removeField(chkbxId);
                $form.data('validationEngine').addField(JSON.parse("{\"" + chkbxId + "\" : { \"checkboxRequired\" : \"" + chkbxId + "-required\" }}"));
                $chkbx.prop("checked", true);
            } else {
                $('.' + chkbxId + '-required', $form).removeClass("error");
                $form.data('validationEngine').removeField(chkbxId);
                $chkbx.prop("checked", false);
            }
        });
    });

    $form.on('click', '.js-clear-loyalty', function () {
        $('input.single-check:checked').prop('checked', false);
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterSuccess, form, form.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.RegisterFailure, form, function (envelope) {
        form.onFailure(envelope);
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileSuccess, form, function (envelope) {
        var data = envelope.message.data;

        //if status 409 mobile exists in multiple members
        if (data.StatusCode === 409) {
            var loyaltyErrorWrapper = $loyaltyErrorWrapper.get(0);
            $('span.error-message', loyaltyErrorWrapper).html(data.ResponseMessage);
            $loyaltyErrorWrapper.show();

            return;
        }

        form.setIsRegistered(data.StatusCode === 200);
        sessionStorage.setItem('LoyaltyMobilePhone', formData.mobilePhone);
        window.location = window.location.origin + data.LoyaltyRegistrationUrl;
    });

    Vendd.MessageBus.subscribe(Vendd.Loyalty.Messages.CheckByMobileFailure, form, function () {
        form.loading(false);
        toastr.error('Something went wrong');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, form, function (envelope) {
        if (formData.registerToLoyalty || formData.alreadyRegisteredToLoyalty)
            return;

        var returnUrl = decodeURIComponent(LhApp.Function.QueryString.getValueOf('ReturnUrl', window.location.href));
        if (returnUrl) document.location.href = returnUrl;
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberSuccess, form, function (envelope) {
        var data = envelope.message.data.model.data;
        if (data.ErrorCode) {
            $('.loyaltyMemberCardNumber-invalid', $form).show().closest('.form-row').addClass('with-error');
            loyaltyMemberCardNumberIsValid = false;
        } else {
            $('.loyaltyMemberCardNumber-invalid', $form).hide().closest('.form-row').removeClass('with-error');
            loyaltyMemberCardNumberIsValid = true;
        }
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetMemberByLoyaltyNumberFailed, form, function (envelope) {
        var message = envelope.message.data.model.message;
        toastr.error(message);
        loyaltyMemberCardNumberIsValid = false;
        $('.js-submit-button', $form).removeAttr('disabled');
    });

    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, form, form.submit);

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetAreasForPostCodeSuccess, form, form.getAreasForPostCode);

});
